export enum UserStatusEnum {
  ACTIVE = 0,
  INACTIVE = 1,
  BLOCKED = 2,
  PENDING = 3,
}

export const UserStatusLabels: Record<UserStatusEnum, string> = {
  [UserStatusEnum.ACTIVE]: "Ativo",
  [UserStatusEnum.INACTIVE]: "Inativo",
  [UserStatusEnum.BLOCKED]: "Bloqueado",
  [UserStatusEnum.PENDING]: "Pendente",
};

export const USER_STATUS_OPTIONS = [
  { value: "0", label: UserStatusLabels[UserStatusEnum.ACTIVE] },
  { value: "2", label: UserStatusLabels[UserStatusEnum.BLOCKED] },
  { value: "3", label: UserStatusLabels[UserStatusEnum.PENDING] },
];

export default UserStatusEnum;
